// extracted by mini-css-extract-plugin
export default {"pageWrapper":"TokenMarketsPage-module__pageWrapper--LhIbk","content":"TokenMarketsPage-module__content--uBvtI","marketsList":"TokenMarketsPage-module__marketsList--aa9kp"};